var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "toll"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_314_906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 82,
    height: 82,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_314_906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "toll_2",
    d: "M51.2496 68.3334C43.619 68.3334 37.1558 65.6855 31.86 60.3897C26.5642 55.0938 23.9163 48.6306 23.9163 41.0001C23.9163 33.3695 26.5642 26.9063 31.86 21.6105C37.1558 16.3147 43.619 13.6667 51.2496 13.6667C58.8801 13.6667 65.3433 16.3147 70.6392 21.6105C75.935 26.9063 78.5829 33.3695 78.5829 41.0001C78.5829 48.6306 75.935 55.0938 70.6392 60.3897C65.3433 65.6855 58.8801 68.3334 51.2496 68.3334ZM23.9163 67.4792C17.8801 65.8848 12.9545 62.639 9.13918 57.7418C5.3239 52.8445 3.41626 47.264 3.41626 41.0001C3.41626 34.7362 5.3239 29.1556 9.13918 24.2584C12.9545 19.3612 17.8801 16.1154 23.9163 14.5209V21.6959C19.8163 23.1195 16.5135 25.5966 14.0079 29.1272C11.5024 32.6577 10.2496 36.6154 10.2496 41.0001C10.2496 45.3848 11.5024 49.3424 14.0079 52.873C16.5135 56.4036 19.8163 58.8806 23.9163 60.3043V67.4792ZM51.2496 61.5001C56.944 61.5001 61.7843 59.507 65.7704 55.5209C69.7565 51.5348 71.7496 46.6945 71.7496 41.0001C71.7496 35.3056 69.7565 30.4654 65.7704 26.4792C61.7843 22.4931 56.944 20.5001 51.2496 20.5001C45.5551 20.5001 40.7149 22.4931 36.7288 26.4792C32.7426 30.4654 30.7496 35.3056 30.7496 41.0001C30.7496 46.6945 32.7426 51.5348 36.7288 55.5209C40.7149 59.507 45.5551 61.5001 51.2496 61.5001Z",
    fill: "#F57423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.f0118b0ddddba9c601dd5b9872b3a748.svg";
export { ForwardRef as ReactComponent };